import { useDispatch } from 'react-redux'
import styles from './Viewer.module.scss'
import S from '../combosDrawsTemplate/settings'
import { setLineSPFData } from '../Redux/_actions/viewer'
import { getMaxMinMatrixCellValue } from './utils'
import { checkCardInFilters } from '../helpers/helpers'

export const getMatrixCellsObjects = ({
	isStrategy,
	structure,
	filter,
	field,
	filterOpacity,
	weight,
	isMoveOpacityFiltersMode,
	isOnePlayer,
	isNormalize,
	selectedArr,
	onSelectedHandChanged,
	heroHandIndex,
	lineSPFData,
	threshold,
	isMultiStack,
}) => {
	const dispatch = useDispatch()

	const { absMatrixMax, fieldMatrixMax, fieldMatrixMin } = getMaxMinMatrixCellValue({
		isStrategy,
		structure,
		combos: filter.combos,
		draws: filter.draws,
		suits: filter.suits,
		field,
		threshold,
	})

	const availableAction = structure.find((item) => item)

	const table = []
	const { RANKS } = S
	let trainerCardIndex

	for (let i = 0; i < 13; i += 1) {
		const children = []
		for (let j = 0; j < 13; j += 1) {
			const vals = []

			let filtered_count = 0.0
			let allCardsCount = 0
			let filtered_opacity = 0.0
			let filtered_eqBuckets_opacity = 0.0
			let filtered_both_combos_draws = 0.0
			let cardsCountStrategy = 0
			let allCardsCountStrategy = 0

			let allAbs = 0

			// let allAbsOverFilters = 0

			let cellValue = 0

			const cards = !isStrategy ? structure[i + 13 * j]?.c : availableAction.values[i + 13 * j].c

			for (let k = 0; k < cards?.length; k++) {
				const c = cards[k]

				if (heroHandIndex && heroHandIndex === c.index) {
					trainerCardIndex = i + 13 * j
				}

				const fieldValue = field === 'abs' ? c[field] : c[field] / 100

				const isCardInFilter = checkCardInFilters(c, filter.combos, filter.draws, filter.suits, threshold)

				const checkIfInEqBucket = filter.eqBuckets.some((el) => c.eq > el[0] && c.eq <= el[1])

				const checkComboOpacity = filterOpacity.combosOpacity.includes(c.com)
				const checkDrawOpacity = filterOpacity.drawsOpacity.includes(c.draw)

				const checkEqBucketsOpacity = filterOpacity.eqBuckets.some(
					(el) => Math.ceil(c.eq) > el[0] && Math.ceil(c.eq) <= el[1]
				)

				/*
				 * вообщем если подумать то эта механика с трешхолдом наверное должна работать следующим образом,
				 * расчитываем как в ренже сейчас процент для каждой ячейки,
				 * потом если этот процент для ячейки меньши трешхолда то не рисуем ячеку вообще,
				 * это правило типо для всех режимов применяется. Но это сейчас просто мысли делать пока этого не надо*/

				allCardsCount++
				// allAbsOverFilters += c.abs

				if (isCardInFilter && checkIfInEqBucket) {
					if (isStrategy && field === 'ev') {
						cellValue += (c.mainEv / 100) * c.abs
					} else {
						cellValue += fieldValue * c.abs
					}

					allAbs += c.abs
					filtered_count++
				}

				/* opacity*/

				if (isCardInFilter && checkEqBucketsOpacity && checkIfInEqBucket) {
					filtered_eqBuckets_opacity++
				}

				if (checkComboOpacity && checkDrawOpacity && c.abs > threshold) {
					filtered_opacity++
				}
				if ((!checkComboOpacity || !checkDrawOpacity) && c.abs > threshold) {
					filtered_both_combos_draws++
				}
			}

			if (field === 'abs') {
				cellValue = allAbs / allCardsCount
			} else {
				cellValue /= allAbs
			}

			if (isStrategy) {
				for (let z = 0; z < structure.length; z++) {
					// add only
					const action = structure[z]

					if (!action && (filter.activeActions.indexOf(z) > -1 || filter.activeActions.length === 0)) {
						vals.push(null)
						continue
					}

					if (filter.activeActions.length === 0 || filter.activeActions.indexOf(action?.id) > -1) {
						// push to vals
						vals.push({
							action: action.action,
							raiseIndex: action.raiseIndex,
							id: action.id,
							stack: availableAction.stack,
							position: availableAction.position,
							rake: availableAction.rakeOpenName,
							openRaise: availableAction.rakeOpenName,
							cards: action.values[i + 13 * j],
							isAllIn: action.isAllIn,
						})

						// get the number of cards available
						cardsCountStrategy += action.values[i + 13 * j].c.length
					}

					allCardsCountStrategy += action !== null && action.values[i + 13 * j].c.length
				}
			}

			const printCards =
				isStrategy && isMultiStack
					? allCardsCountStrategy
					: isStrategy && !isMultiStack
					? cardsCountStrategy
					: filtered_count

			// required
			const card_str = i === j ? RANKS[i] + RANKS[j] : i > j ? `${RANKS[j] + RANKS[i]}o` : `${RANKS[i] + RANKS[j]}s`

			// check if there are cards to display
			const isHidden = printCards === 0 ? styles.hidden : ''

			const isOpacity = (function () {
				/* IIFE (Immediately Invoked Function Expression) */

				if (filtered_opacity === 0 && filtered_both_combos_draws === 0 && isMoveOpacityFiltersMode) {
					return styles.filterOpacity
				}

				if (filtered_opacity !== 0 && filtered_both_combos_draws === 0 && isMoveOpacityFiltersMode) {
					return styles.filterOpacity
				}
				if (filtered_opacity !== 0 && filtered_both_combos_draws !== 0 && isMoveOpacityFiltersMode) {
					return styles.filterNoOpacity
				}
			})()

			/* there was round*/
			const isEqBucketOpacity = filtered_eqBuckets_opacity !== 0 ? styles.filterNoOpacity : styles.filterOpacity

			if (isHidden && isOnePlayer && selectedArr.includes(i + 13 * j) && !isMultiStack) {
				const newCells = selectedArr.filter((el) => el !== i + 13 * j)

				onSelectedHandChanged(newCells)

				if (lineSPFData.selectedMatrixIndex.includes(i + 13 * j)) {
					dispatch(setLineSPFData({ selectedMatrixIndex: newCells }))
				}
			}

			const cellIndex = i + 13 * j

			if (!isHidden) {
				if (isStrategy) {
					children.push({
						cellIndex,
						i,
						j,
						vals,
						isHidden,
						isStrategy,
						cardString: card_str,
						weight,
						filter,
						field,
						stack: availableAction?.stack,
						position: availableAction.position,
						rake: availableAction.rakeOpenName,
						openRaise: availableAction.rakeOpenName,
						matrixFields: {
							absMatrixMax,
							fieldMatrixMax,
							fieldMatrixMin,
						},
						isOpacity,
						isEqBucketOpacity,
						s1: null,
						s2: null,
						text: card_str,
						played: cellValue,
						addedData: cellValue,
						isOnePlayer,
						isNormalize,
						cellSelected: selectedArr.includes(i + 13 * j),
						trainerCardIndex: trainerCardIndex && trainerCardIndex,
						isShowCellTooltip: filtered_count > 0,
					})
				} else {
					children.push({
						cellIndex,
						i,
						j,
						vals: cards,
						isStrategy,
						isHidden,
						weight,
						filter,
						field,
						matrixFields: {
							absMatrixMax,
							fieldMatrixMax,
							fieldMatrixMin,
						},
						isOpacity,
						isEqBucketOpacity,
						text: card_str,
						played: cellValue,
						isOnePlayer,
						isNormalize,
						cellSelected: selectedArr.includes(i + 13 * j),
						trainerCardIndex: trainerCardIndex && trainerCardIndex,
						isShowCellTooltip: filtered_count > 0,
					})
				}
			} else {
				children.push({
					isHidden,
					cellIndex,
					stack: availableAction?.stack,
					position: availableAction.position,
					rake: availableAction.rakeOpenName,
					openRaise: availableAction.rakeOpenName,
				})
			}
		}

		table.push(children)
	}

	return table
}
